import {useLocalizationContext} from '@mui/x-date-pickers/internals'

export const callAll =
	(...fns: (Function | undefined)[]) =>
	(...args: any[]) =>
		fns.forEach((fn) => fn && fn(...args));

export const jsonStringify = <T>(value: T, spacing = 4) => JSON.stringify(value, null, spacing);

const development: boolean = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export function isDev(): boolean {
	return development;
}

export function sleep(delay = 0) {
	return new Promise((resolve) => {
		setTimeout(resolve, delay);
	});
}

export function propertyExists<X, Y extends PropertyKey>(
  obj: X,
  prop: Y
): obj is X & Record<Y, unknown> {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    Object.prototype.hasOwnProperty.call(obj, prop)
  )
}

export function getTimezone<TDate>(
  adapter: ReturnType<typeof useLocalizationContext>,
  value: TDate
): string | null {
  return value == null || !adapter.utils.isValid(value as unknown as Date)
    ? null
    : adapter.utils.getTimezone(value as unknown as Date)
}